import { BaseModel } from 'api/models/base.model';
import { JsonName } from 'tserialize';

export class PublishSiteResponse extends BaseModel {
  @JsonName()
  result!: boolean;

  @JsonName()
  message!: string;
}